import React from 'react';

const Unauthorized: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>401 - No autorizado</h1>
      <p>No tienes permiso para acceder a esta página.</p>
    </div>
  );
};

export default Unauthorized;